module.exports = require('../../full/object/set-prototype-of');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/features/object/set-prototype-of.js
// module id = 479
// module chunks = 0 1